import { Injectable } from '@angular/core';
import { FilterMatchMode } from 'primeng/api';
import { FilterInfo } from 'src/app/backend-client/models/Backend/Core/Api/Models/filter-info';
import { getDateToBackend } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class MxFilterService {
  constructor() {}

  static getQueryRequestFilterInfo(lazyLoadFilters: any): FilterInfo[] {
    const queryRequestFilterInfo: FilterInfo[] = [];
    Object.keys(lazyLoadFilters).forEach((key) => {
      if (key !== 'global') {
        const filter = { ...lazyLoadFilters[key][0] };
        if (filter) {
          if (filter.value !== null) {
            if (filter.matchMode === FilterMatchMode.BETWEEN) {
              queryRequestFilterInfo.push({
                selector: key,
                matchMode: this.getFilterInfoMatchMode(
                  FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
                ),
                value: this.getFilterInfoValue(
                  filter.value[1],
                  FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
                ),
              });
              queryRequestFilterInfo.push({
                selector: key,
                matchMode: this.getFilterInfoMatchMode(
                  FilterMatchMode.LESS_THAN_OR_EQUAL_TO
                ),
                value: this.getFilterInfoValue(
                  filter.value[1],
                  FilterMatchMode.LESS_THAN_OR_EQUAL_TO
                ),
              });
            } else {
              queryRequestFilterInfo.push({
                selector: key,
                matchMode: this.getFilterInfoMatchMode(filter.matchMode),
                value: this.getFilterInfoValue(filter.value, filter.matchMode),
              });
            }
          }
        }
      }
    });

    return queryRequestFilterInfo;
  }

  private static getFilterInfoMatchMode(matchMode: FilterMatchMode) {
    switch (matchMode) {
      case FilterMatchMode.CONTAINS:
        return MxMatchMode.Contains;
      case FilterMatchMode.NOT_CONTAINS:
        return MxMatchMode.NotContains;
      case FilterMatchMode.IN:
        return MxMatchMode.In;
      case FilterMatchMode.STARTS_WITH:
        return MxMatchMode.StartsWith;
      case FilterMatchMode.ENDS_WITH:
        return MxMatchMode.EndsWith;
      case FilterMatchMode.LESS_THAN_OR_EQUAL_TO:
        return MxMatchMode.LessThanOrEquals;
      case FilterMatchMode.LESS_THAN:
        return MxMatchMode.LessThan;
      case FilterMatchMode.GREATER_THAN_OR_EQUAL_TO:
        return MxMatchMode.GreaterThanOrEquals;
      case FilterMatchMode.GREATER_THAN:
        return MxMatchMode.GreaterThan;
      case FilterMatchMode.EQUALS:
        return MxMatchMode.Equals;
      case FilterMatchMode.NOT_EQUALS:
        return MxMatchMode.NotEquals;
      case FilterMatchMode.IS:
        return MxMatchMode.Equals;
      case FilterMatchMode.IS_NOT:
        return MxMatchMode.NotEquals;
      case FilterMatchMode.BEFORE:
        return MxMatchMode.LessThan;
      case FilterMatchMode.AFTER:
        return MxMatchMode.GreaterThan;
      case FilterMatchMode.DATE_IS:
        return MxMatchMode.Equals;
      case FilterMatchMode.DATE_IS_NOT:
        return MxMatchMode.NotEquals;
      case FilterMatchMode.DATE_BEFORE:
        return MxMatchMode.LessThan;
      case FilterMatchMode.DATE_AFTER:
        return MxMatchMode.GreaterThan;
      default:
        return MxMatchMode.Equals;
    }
  }

  private static getFilterInfoValue(value: any, matchMode: FilterMatchMode) {
    if (matchMode === FilterMatchMode.IN) {
      let ret = '';
      (value as any[]).forEach((element, i) => {
        ret =
          i === value.length - 1 ? `${ret}${element}` : `${ret}${element}||`;
      });

      return ret;
    } else if (
      matchMode === FilterMatchMode.DATE_IS ||
      matchMode === FilterMatchMode.DATE_IS_NOT ||
      matchMode === FilterMatchMode.DATE_BEFORE ||
      matchMode === FilterMatchMode.DATE_AFTER
    ) {
      return getDateToBackend(value);
    }
    return value.toString();
  }
}

export enum MxMatchMode {
  Contains = 'contains',
  NotContains = 'notcontains',
  StartsWith = 'startswith',
  EndsWith = 'endswith',
  Equals = '=',
  NotEquals = '<>',
  GreaterThan = '>',
  GreaterThanOrEquals = '>=',
  LessThan = '<',
  LessThanOrEquals = '<=',
  In = 'in',
}
